module.exports = __webpack_public_path__ + "static/media/547987.984b3d41.svg";